export const AIMessageStyles = {
    root: {
        width: '100%'
    },
    messageContainer: {
        position: 'relative',
        padding: "10px 16px",
        borderRadius: "16px 16px 16px 0",
        gap: '7px'
    },
    content: {
        textAlign: 'left',
    },
    actionButtons: {
        padding: '2px 4px',
        // backgroundColor: tokens.colorNeutralBackground1,
        position: 'absolute',
        bottom: '-15px',
        left: '25px',
        // borderRadius: tokens.borderRadiusMedium,
        height: '28px',
        // boxShadow: tokens.shadow4
    }
};
